import React from "react";

function BS4_GridSmall() {
  return (
    <div>
      <h1>BS4_GridSmall Component</h1>
      <p>This is the BS4_GridSmall tutorial page content.</p>
    </div>
  );
}

export default BS4_GridSmall;
